export const PAGES = ["Home","About","Stakeholders","Research","Mission","Training","Objectives","Way Forward","Events","Contact Us"];

export const ALL_STAKEHOLDERS = [
  { label: "Indian Navy",          img: "uploads/1.png",  color: "#3B82F6" },
  { label: "BSF",                  img: "uploads/2.png",  color: "#60A5FA" },
  { label: "BRO",                  img: "uploads/3.png",  color: "#EF4444" },
  { label: "CISF",                 img: "uploads/4.png",  color: "#8B5CF6" },
  { label: "Dept. of Space",       img: "uploads/5.png",  color: "#0EA5E9" },
  { label: "Indian Air Force",     img: "uploads/6.png",  color: "#10B981" },
  { label: "NSG",                  img: "uploads/7.png",  color: "#F59E0B" },
  { label: "Coast Guard",          img: "uploads/8.png",  color: "#D97706" },
  { label: "Indian Army",          img: "uploads/9.png",  color: "#059669" },
  { label: "BRO",                  img: "uploads/10.png", color: "#16A34A" },
  { label: "NSG",                  img: "uploads/11.png", color: "#A78BFA" },
  { label: "BSF",                  img: "uploads/12.png", color: "#F97316" },
  { label: "ITBP",                 img: "uploads/13.png", color: "#14B8A6" },
  { label: "DRDO",                 img: "uploads/14.png", color: "#6366F1" },
  { label: "RAW",                  img: "uploads/15.png", color: "#DC2626" },
  { label: "NIA",                  img: "uploads/16.png", color: "#0891B2" },
  { label: "DAE",                  img: "uploads/17.png", color: "#7C3AED" },
  { label: "ISRO",                 img: "uploads/18.png", color: "#B45309" },
  { label: "State Police",         img: "uploads/19.png", color: "#475569" },
];

export const NEWS_ITEMS = [
  { date: "May 2025", title: "Expert Talk: Cyber & Electronic Warfare Dimensions of Operation Sindoor", desc: "Distinguished experts delivered an in-depth talk on cyber and electronic warfare aspects, analysing strategic lessons from Operation Sindoor." },
  { date: "Apr 2025", title: "T-SATS 2025 — Technology Symposium on Advanced Technology for Security", desc: "A flagship symposium bringing together defence scientists, industry leaders, and academic researchers to explore cutting-edge security technologies." },
  { date: "Jan 2025", title: "Tech-Tiranga Conclave 2025 — Indigenous Defence Innovation Summit", desc: "A premier summit showcasing indigenous defence innovation, bringing together startups, DRDO labs, and academic institutions to accelerate Atmanirbhar Bharat in defence." },
  { date: "Oct 2024", title: "Cybersecurity Awareness Month — CRENS Outreach Campaign", desc: "CRENS conducted a month-long outreach campaign to promote cybersecurity awareness among students, professionals, and the broader security community." },
];

export const ADVISORY_BOARD = [
  { sn: 1, name: "Shri Ajay Kumar", designation: "Former Secretary, Ministry of Defence", position: "Chairperson" },
  { sn: 2, name: "Prof. V. Ramgopal Rao", designation: "Vice Chancellor, BITS Pilani", position: "Member" },
  { sn: 3, name: "Dr. Samir V. Kamat", designation: "Chairman, DRDO & SA to RM", position: "Member" },
  { sn: 4, name: "Dr. S. Somanath", designation: "Chairman, ISRO", position: "Member" },
  { sn: 5, name: "Lt Gen. Upendra Dwivedi (Retd.)", designation: "Former Chief of Army Staff", position: "Member" },
  { sn: 6, name: "Air Marshal Anil Khosla (Retd.)", designation: "Former Chief of Air Staff", position: "Member" },
  { sn: 7, name: "Vice Adm. Dinesh K. Tripathi (Retd.)", designation: "Former Chief of Naval Staff", position: "Member" },
  { sn: 8, name: "Shri Sanjay Bahl", designation: "Director General, CERT-In", position: "Member" },
  { sn: 9, name: "Prof. Amrita Priyadarshini", designation: "Dean, CRENS @ BITS Pilani", position: "Member Secretary" },
];

export const STEERING_COMMITTEE = [
  { name: "Prof. V. Ramgopal Rao", role: "Vice Chancellor, BITS Pilani" },
  { name: "Prof. Amrita Priyadarshini", role: "Dean, CRENS" },
  { name: "Brig. Anil Sharma (Retd.)", role: "Strategic Advisor" },
  { name: "Dr. Debashis Chatterjee", role: "Director, IIT Kharagpur" },
  { name: "Shri P.K. Mishra", role: "Principal Advisor, MHA" },
  { name: "Dr. G. Satheesh Reddy", role: "Former Chairman, DRDO" },
  { name: "Prof. Rajendra K. Bose", role: "Professor, BITS Pilani Hyderabad" },
  { name: "Shri Rajesh Pant", role: "Former Nat. Cyber Security Coordinator" },
  { name: "Dr. Manindra Agrawal", role: "Professor, IIT Kanpur" },
  { name: "Ms. Ananya Singh", role: "Joint Secretary, MeitY" },
  { name: "Cmdr. Vikram Nair (Retd.)", role: "Head, Defence Innovation" },
  { name: "Dr. Priya Rajan", role: "Research Director, CRENS" },
];

export const RESEARCH_FACILITIES = [
  "Advanced Computing and Simulation Laboratory",
  "Cyber Security Research Laboratory (CySRL)",
  "Embedded Systems & IoT Security Lab",
  "RF and Microwave Engineering Laboratory",
  "Quantum Computing Research Facility",
  "Satellite Communication Research Lab",
  "Unmanned Systems Research Centre",
  "Advanced Materials Processing Laboratory",
  "High-Performance Computing Cluster",
  "Cryptography & Network Security Lab",
  "Defence Systems Integration Testbed",
];

export const CONCLUDED_PROJECTS = [
  "Indigenous Secure Routing Protocol for Tactical Networks",
  "Post-Quantum Cryptography Implementation for DRDO Systems",
  "AI-Enabled Border Surveillance Framework",
  "Satellite Image Analysis for Strategic Intelligence",
  "Electromagnetic Pulse Protection for Communication Nodes",
  "Undersea Cable Security Assessment",
  "Hybrid Threat Grid Architecture for Defence Establishments",
  "Resilient Tower Grid Architecture for Defence Establishments",
  "Drone Swarm Detection and Countermeasure System",
  "Advanced Biometric Authentication for Secure Facilities",
  "CBRN Agent Detection Using Nano-sensor",
  "Cyber Range Development for Red Team Exercises",
  "Signal Jamming Resistant Communication Links",
  "Autonomous Logistics for Forward Operating Bases",
  "Anti-Spoofing Mechanisms for GPS-Dependent Systems",
  "Social Media Analytics for Counter-Terrorism",
  "Electronic Warfare Simulation Environment",
  "Secure Multi-Party Computation Protocols",
  "Satellite-Ground Station Security Hardening",
  "Advanced Encryption for Field Communication Devices",
  "Thermal Imaging Enhancement Algorithms",
  "Lightweight Cryptography for IoT in Defence",
  "Adversarial Robustness of AI Vision Systems",
  "Quantum Key Distribution Testbed",
  "Cognitive Radio for Dynamic Spectrum Management",
  "Federated Learning for Distributed Surveillance",
  "Detection of Deepfake Threats in Strategic Communication",
  "Secure Voting Systems for Remote Operations",
  "Acoustic Sensor Networks for Perimeter Security",
  "Anti-Drone Jamming using Software-Defined Radio",
  "Cyber-Physical System Security for Naval Vessels",
  "Secure Blockchain for Defence Supply Chain",
  "Threat Intelligence Fusion Platform",
];

export const ONGOING_PROJECTS = [
  "Next-Generation Firewall for SCADA Systems",
  "AI-Driven Cyber Threat Attribution",
  "Quantum-Safe VPN for Field Communications",
  "Integrated Air Defence Network Simulation",
  "Space Situational Awareness Platform",
  "Indigenous Processor for Secure Applications",
  "Smart Border Surveillance Using Multi-Sensor Fusion",
  "Predictive Maintenance for Defence Equipment",
  "Zero-Trust Architecture for NGO Networks",
  "Autonomous Mine Detection System",
  "Covert Channel Detection in Network Traffic",
  "Laser Communication for Beyond-Line-of-Sight",
  "EW Signal Classification Using Deep Learning",
  "Wearable Health Monitoring for Soldiers",
  "Adaptive Camouflage Materials",
  "Hyperspectral Imaging for Target Detection",
  "Digital Twin for Naval Vessel Lifecycle",
  "AI-Powered Language Processing for SIGINT",
  "Resilient Mesh Networks for Tactical Ops",
  "Offensive Cyber Capability Framework",
];

export const TECH_FIELDS = [
  "Cybersecurity & Cyber Warfare","Quantum Computing & Communications","Artificial Intelligence & ML",
  "Unmanned Aerial Systems","Electronic Warfare","Space Security & Satellite Systems",
  "Signal Intelligence (SIGINT)","Directed Energy Weapons","Hypersonic Technologies",
  "Advanced Materials for Defence","Geospatial Intelligence","Autonomous Systems & Robotics",
  "Counter-Drone Technologies","Network-Centric Warfare","Radar & Sonar Systems",
  "Secure Communications","Bio-security & CBRN Defence","Big Data & Predictive Analytics",
  "Blockchain for Defence","Edge Computing & IoT Security","5G/6G Security",
  "Additive Manufacturing","Nanotechnology for Defence","Critical Infrastructure Protection",
  "Information Operations","Naval Propulsion & Systems","Advanced Avionics",
  "Anti-Submarine Warfare","Missile Guidance Systems","Nuclear Safety & Security",
  "Resilient Command & Control",
];

export const TRAINING_DOMAINS = [
  { icon: "/uploads/Cybersecurity.svg", label: "Cybersecurity" },
  { icon: "/uploads/Wind-Tunnel-Facility-3.svg", label: "Space Security" },
  { icon: "/uploads/AI-&-ML.svg", label: "AI & Machine Learning" },
  { icon: "/uploads/Electronic-Warfare.svg", label: "Electronic Warfare" },
  { icon: "/uploads/Network.svg", label: "Network Defence" },
  { icon: "/uploads/Information.svg", label: "Information Security" },
  { icon: "/uploads/Intelligency.svg", label: "Intelligence Analysis" },
  { icon: "/uploads/Post-Optical-System-2.svg", label: "Signal Processing" },
  { icon: "/uploads/Critical.svg", label: "Critical Infrastructure" },
  { icon: "/uploads/Emerging.svg", label: "Emerging Technologies" },
];

export const TRAINING_DROPDOWN = [
  { label: "Training Overview",                              sub: "overview",       soon: false },
  { label: "Professional Development Course in Cybersecurity", sub: "cybersecurity",  soon: false },
  { label: "Quantum Communications Course",                  sub: "quantum",        soon: true  },
];

